import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Card, Loading, TimeLineEvents, ToastContext } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import useTimeLineComment from '@/common/hooks/useTimeLineComment/useTimeLineComment'
import parcelServices from '@/parcels/services/services'

import { parcelTimelineSource } from './constants'
import { getParcelTimelineEvents, mapUserToAtValue } from './helpers'

const ParcelTimelineCard = ({ parcel, fetchParcel }) => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)

  const { loading, onDeleteTimelineImage, onSelectTimelineImages, sendTimelineComment, users, selectedTimelineImages } =
    useTimeLineComment({
      fetchTimeline: fetchParcel,
      storeId: info?.selectedStore?.id,
      resourceId: parcel?.id,
      setToastInfo,
      sendCommentService: parcelServices.sendParcelComment,
      uploadProductImageService: parcelServices.uploadParcelImage,
    })

  const timeline = getParcelTimelineEvents(parcel, t)
  const atValues = users?.results?.map(mapUserToAtValue)

  return (
    <Card showBorder={false}>
      <Loading show={loading}>
        <TimeLineEvents
          source={parcelTimelineSource}
          timeline={timeline}
          onSubmit={sendTimelineComment}
          onSelectImages={onSelectTimelineImages}
          selectedImages={selectedTimelineImages}
          onDeleteImage={onDeleteTimelineImage}
          userImage={info?.userInfo?.profile_picture_url}
          timezone={info?.selectedStore?.timezone}
          currentUser={info?.userInfo}
          atValues={atValues}
        />
      </Loading>
    </Card>
  )
}

export default ParcelTimelineCard
